<template>
    <div class="container">
        <back-button location="/technologies"></back-button>

        <h1 class="title">Fun Stuff</h1>
        <div class="logo swing-animation">
            <img src="../../assets/images/FunStuff.svg"/>
        </div>
        <div class="content">
            <div class="mobile-version-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">Breakdown of how Entelectuals feel about their desk space</p>
                    <apex-charts type="donut" :options="availabilityOptions" :series="availabilitySeries"
                                class="chart"></apex-charts >
                </div>
                <p class="fun-fact">
                    Rock, EDM, Hip hop, and Instrumental music are the genres most listened to while coding
                </p>
            </div>
            <div class="mobile-module-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">Some fun comparisons to see what is more popular among Entelectuals</p>
                    <apex-charts type="bar" :options="phonesOptions" :series="phonesSeries" class="chart" height="120"></apex-charts>
                    <apex-charts type="bar" :options="gamingOptions" :series="gamingSeries" class="chart" height="120"></apex-charts>
                    <apex-charts type="bar" :options="consoleOptions" :series="consoleSeries" class="chart" height="120"></apex-charts>
                    <apex-charts type="bar" :options="foodOptions" :series="foodSeries" class="chart" height="120"></apex-charts>
                </div>
            </div>
            <div class="mobile-serve-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">What Entelectuals like to drink as coding fuel</p>
                    <apex-charts type="radialBar" :options="platformOptions" :series="platformSeries"
                                class="chart"></apex-charts >
                </div>
                <p class="fun-fact">
                    Comedy, Sci-fi, Action, and Adventure are Entelectuals' favourite movie genres
                </p>
            </div>
            <div class="mobile-build-chart">
                <p class="fun-fact">
                    42% of Entelectuals think Thanos was right
                </p>
                <div class="chart-group">
                    <p class="chart-sub-title">Average number of hours sleep that Entelectuals get in each night</p>
                    <apex-charts type="bar" :options="serveOptions" :series="serveSeries" class="chart" height="300px"></apex-charts >
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import VueApexCharts from "vue-apexcharts/src";
    import BackButton from "../../widgets/BackButton";

    export default {
        components: {
            'apex-charts': VueApexCharts,
            BackButton
        },
        data: function () {
            return {
                platformOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['#F7941D', '#008AD0', '#B51E8E', '#009EA5'],
                    labels: ['Coffee', 'Water', 'Tea', 'Other'],
                    tooltip: {
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                    stroke: {
                        width: 0
                    },
                    fill: {
                        patern: {
                            width: 500
                        }
                    },
                    dataLabels: {
                        name: {
                            show: false,

                        },
                        value: {
                            show: false,
                        },
                        formatter: function (val, opt) {
                            if (val < 5)
                                return '';
                            return `${opt.globals.labels[opt.seriesIndex]}: ${val}%`;
                        },
                    },
                    plotOptions: {
                        radialBar: {
                            offsetY: -30,
                            startAngle: 0,
                            endAngle: 300,
                            hollow: {
                                margin: 5,
                                size: '30%',
                                background: 'transparent',
                                image: undefined,
                            },
                            track: {
                                opacity: 0.1
                            },
                            dataLabels: {
                                name: {
                                    show: false,
                                },
                                value: {
                                    color: '#fff',
                                    offsetY: 4
                                }
                            }
                        }
                    },
                    legend: {
                        show: true,
                        floating: true,
                        fontSize: '16px',
                        position: 'left',
                        verticalAlign: 'top',
                        textAnchor: 'end',
                        labels: {
                            useSeriesColors: true,
                        },
                        markers: {
                            size: 0
                        },
                        itemMargin: {
                            vertical: 4,
                        },
                        containerMargin: {
                            left: 160,
                            top: 16
                        }
                    },
                    responsive: [{
                        breakpoint: 599,
                        options: {
                            legend: {
                                show: true,
                                fontSize: '16px',
                                position: 'bottom',
                                textAnchor: 'start',
                                labels: {
                                    useSeriesColors: false,
                                    color: '#fff'
                                },
                                markers: {
                                    size: 5
                                },
                                containerMargin: {
                                    left: 0,
                                    top: 0
                                }
                            },
                            plotOptions: {
                                radialBar: {
                                    offsetY: 0,
                                    startAngle: 270,
                                    endAngle: 90,
                                }
                            },
                        }
                    }]
                },
                platformSeries: [62.8, 18.4, 10.1, 8.7],
                availabilityOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    legend: {
                        labels: {
                            color: '#FFF'
                        },
                        position: 'bottom',
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: (value) => `${Math.round(value)}%`
                    },
                    colors: ['#F7941D', '#008AD0', '#B51E8E', '#009EA5'],
                    labels: ['Don\'t touch my desk', 'My desk is your desk', 'What desk?'],
                    tooltip: {
                        enabled: true,
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                    stroke: {
                        width: 0
                    },
                    fill: {
                        patern: {
                            width: 500
                        }
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '50%',
                            },
                        }
                    }
                },
                availabilitySeries: [42, 44, 14],
                serveOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['#B51E8E', '#009EA5', '#F7941D', '#008AD0', '#00994C'],
                    labels: ['<6 hours', '6 hours', '7 hours', '8 hours', '>8 hours'],
                    plotOptions: {
                        bar: {
                            columnWidth: '45%',
                            distributed: true
                        }
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    yaxis: {
                        labels: {
                            style: {
                                color: '#FFF',
                            },
                        }
                    },
                    xaxis: {
                        categories: ['<6 hours', '6 hours', '7 hours', '8 hours', '>8 hours'],
                        labels: {
                            style: {
                                colors: '#fff',
                                fontSize: '14px'
                            }
                        }
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        },
                        marker: {
                            show: true
                        }
                    },
                },
                serveSeries: [{
                    name: 'Amount',
                    data: [9.8, 33.3, 36.2, 19.7, 1]
                }],
                phonesOptions: {
                    chart: {
                        stacked: true,
                        stackType: '100%',
                        toolbar: {
                            show: false
                        }
                    },
                    dataLabels: {
                        formatter: (val) => {
                            if (val < 5) {
                                return '';
                            }

                            return `${val}%`;
                        }
                    },
                    colors: ['#008AD0', '#F7941D', '#00994C'],
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    legend: {
                        position: 'top',
                        labels: {
                            color: '#FFF'
                        }
                    },
                    yaxis: {
                        labels: {
                            style: {
                                color: '#FFF',
                            },
                            show: false,
                        }
                    },
                    xaxis: {
                        labels: {
                            style: {
                                colors: '#FFF',
                            }
                        },
                        categories: ['Phone OS'],
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                },
                phonesSeries: [{
                    name: 'Android',
                    data: [80]
                }, {
                    name: 'iOS',
                    data: [20]
                }],
                gamingOptions: {
                    chart: {
                        stacked: true,
                        stackType: '100%',
                        toolbar: {
                            show: false
                        }
                    },
                    dataLabels: {
                        formatter: (val) => {
                            if (val < 5) {
                                return '';
                            }

                            return `${Math.round(val)}%`;
                        }
                    },
                    colors: ['#B51E8E', '#F7941D', '#008AD0', '#F7941D', '#00994C'],
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    legend: {
                        position: 'top',
                        labels: {
                            color: '#FFF'
                        }
                    },
                    yaxis: {
                        labels: {
                            style: {
                                color: '#FFF',
                            },
                            show: false,
                        }
                    },
                    xaxis: {
                        labels: {
                            style: {
                                colors: '#FFF',
                            },
                        },
                        categories: ['Gaming'],
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                },
                gamingSeries: [{
                    name: 'Plays Video Games',
                    data: [80.7]
                }, {
                    name: 'Doesn\'t Game',
                    data: [19.3]
                }],
                consoleOptions: {
                    chart: {
                        stacked: true,
                        stackType: '100%',
                        toolbar: {
                            show: false
                        }
                    },
                    dataLabels: {
                        formatter: (val) => {
                            if (val < 5) {
                                return '';
                            }

                            return `${Math.round(val)}%`;
                        }
                    },
                    colors: ['#008AD0', '#F7941D', '#00994C', '#B51E8E'],
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    legend: {
                        position: 'top',
                        labels: {
                            color: '#FFF'
                        }
                    },
                    yaxis: {
                        labels: {
                            style: {
                                color: '#FFF',
                            },
                            show: false,
                        }
                    },
                    xaxis: {
                        labels: {
                            style: {
                                colors: '#FFF',
                            },
                        },
                        categories: ['Platform'],
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                },
                consoleSeries: [{
                    name: 'Console',
                    data: [26]
                }, {
                    name: 'PC',
                    data: [54.7]
                }, {
                    name: 'Mobile',
                    data: [2.8]
                },{
                    name: 'None',
                    data: [16.5]
                }],
                foodOptions: {
                    chart: {
                        stacked: true,
                        stackType: '100%',
                        toolbar: {
                            show: false
                        }
                    },
                    dataLabels: {
                        formatter: (val) => {
                            if (val < 5) {
                                return '';
                            }

                            return `${val}%`;
                        }
                    },
                    colors: ['#B51E8E', '#F7941D', '#008AD0', '#F7941D', '#00994C'],
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    legend: {
                        position: 'top',
                        labels: {
                            color: '#FFF'
                        }
                    },
                    yaxis: {
                        labels: {
                            style: {
                                color: '#FFF',
                            },
                            show: false,
                        }
                    },
                    xaxis: {
                        labels: {
                            style: {
                                colors: '#FFF',
                            },
                        },
                        categories: ['Food'],
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                },
                foodSeries: [{
                    name: 'Pizza',
                    data: [64]
                }, {
                    name: 'Burger',
                    data: [36]
                }],
            }
        },
        methods: {
            track () {
                this.$ga.page('/2018/technology/funstuff') // This is for Google Analytics tracking
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        display: grid;
        grid-template-columns: 1fr 600px 1fr;
        grid-template-rows: auto 1fr;
        grid-template-areas: 'back title   logo' 'content content content';
        color: white;
        text-align: center;
        background-size: cover;
        background-position: center;
        padding-bottom: 48px;

        @media only screen and (max-width: $screen-sm-max) {
            grid-template-columns: 1fr 2fr 1fr;
        }

        .logo {
            grid-area: logo;
            height: 160px;
            width: 160px;
            align-self: start;
            justify-self: end;
            background: $green;
            border-bottom-left-radius: 100%;
            display: grid;

            @media only screen and (max-width: $screen-xs-max) {
                display: none;
            }

            img {
                width: 50%;
                height: 50%;
                align-self: start;
                justify-self: end;
                margin: 20px;
            }
        }

        .title {
            grid-area: title;
            align-self: center;
            justify-self: center;
            align-content: center;
            justify-content: center;
            margin: 24px;
            display: grid;
        }

        .content {
            grid-area: content;
            display: grid;
            grid-template-areas: '. version module .' '. serve build .';
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-template-rows: auto auto;

            @media only screen and (max-width: $screen-sm-max) {
                grid-template-areas: '. version .' '. module .' '. serve .' '. build .';
                grid-template-columns: 1fr 2fr 1fr;
            }

            .fun-fact {
                align-self: center;
                justify-self: center;
                margin: 24px;
            }

            .chart {
                width: 360px;
                align-self: center;
                justify-self: center;

                @media only screen and (max-width: $screen-xs-max) {
                    width: 250px;
                }
            }

            .chart-group {
                border-left: 2px solid $entelect-orange;
                padding-left: 24px;
                display: grid;
            }

            .chart-title {
                align-self: start;
                justify-self: start;
            }

            .chart-sub-title {
                align-self: start;
                justify-self: start;
                text-align: left;
                margin-bottom: 24px;
            }

            .mobile-version-chart {
                grid-area: version;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .mobile-serve-chart {
                grid-area: serve;
                display: grid;
                padding-top: 24px;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .mobile-module-chart {
                grid-area: module;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .mobile-build-chart {
                grid-area: build;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                    margin: 0;
                }
            }
        }
    }
</style>
